import { cn } from "@/lib/utils";

const CC_NAV_LINK_BASE = "px-1 xl:px-2 py-1 text-xs sm:text-sm xl:text-lg 2xl:text-base";
const CC_NAV_LINK_ACTIVE = "bg-blue-600 text-white rounded";
const CC_NAV_LINK_INACTIVE = "text-[#97AAC4] hover:text-white";

export function getCcNavLinkClassName({ isActive }: { isActive: boolean }) {
  return cn(
    CC_NAV_LINK_BASE,
    isActive ? CC_NAV_LINK_ACTIVE : CC_NAV_LINK_INACTIVE
  );
}
